import { Directive, ElementRef, HostListener, Input, Renderer2 } from "@angular/core";

@Directive({
    selector: "input[kno2AppendFileExtension]",
    exportAs: "kno2AppendFileExtension",
    standalone: false
})
export class AppendFileExtensionDirective {
    private fileExtension = "";
    @Input() public set kno2AppendFileExtension(extension: string) {
        if (extension) this.fileExtension = extension.includes(".") ? extension.split(".")[1] : extension;
    }

    @HostListener("keydown", ["$event"])
    public onKeydown(event: KeyboardEvent): void {
        const { keyCode } = event;
        const inputEl = this.host.nativeElement as HTMLInputElement;
        const inputValue = inputEl.value.trim();

        if (!(keyCode === 13 || keyCode === 9) || !inputValue.length) return;

        const formattedValue = this.addExtension(inputValue);
        if (inputValue != formattedValue) this.updateInputValue(formattedValue);
    }

    @HostListener("focusout")
    @HostListener("blur")
    public onOutOfFocus(): void {
        const inputEl = this.host.nativeElement as HTMLInputElement;
        const inputValue = inputEl.value.trim();

        if (!inputValue.length || !this.fileExtension) return;

        const formattedValue = this.addExtension(inputValue);
        if (inputValue != formattedValue) this.updateInputValue(formattedValue);
    }

    constructor(
        private host: ElementRef,
        private renderer: Renderer2
    ) {}

    private addExtension(value: string): string {
        const extension = this.fileExtension;
        const hasExtension = value.substr(value.length - extension.length) === extension;

        return hasExtension ? value : value + `.${extension}`;
    }

    private updateInputValue(value: string) {
        this.renderer.setProperty(this.host.nativeElement, "value", value);
    }
}
